import { render, staticRenderFns } from "./List.vue?vue&type=template&id=67d5de80&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"
import style0 from "./List.vue?vue&type=style&index=0&id=67d5de80&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d5de80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/shimoyamadayuu/Documents/github/management-site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67d5de80')) {
      api.createRecord('67d5de80', component.options)
    } else {
      api.reload('67d5de80', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=67d5de80&scoped=true", function () {
      api.rerender('67d5de80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/icon/List.vue"
export default component.exports